import { useI18n } from '@/i18n/i18n-context'
import { Card } from '@/ui/card'

/** GET/POST on the three scan routes all fold "unknown assessment" and "terminal or past expiry"
 * into the same bodyless 404 (architecture §5 D-5 Q-2: "404, identical") — this screen matches that
 * by naming no cause either. */
export function ScanUnavailableScreen() {
  const { t } = useI18n()
  return (
    <Card className="flex flex-col gap-2 text-center">
      <h1 className="text-lg font-semibold text-slate-900">{t('scanUnavailable')}</h1>
    </Card>
  )
}
